export default [
  { label: 'NDIA Managed', value: 'ndia-managed' },
  { label: 'Plan Managed', value: 'plan-managed' },
  { label: 'Self Managed', value: 'self-managed' },
]
